module.exports = __webpack_public_path__ + "static/media/quality-slide4.177a8b12.jpg";